<template>
    <div>
        <el-form :inline="true" :model="searchForm"  class="forTbFilter">
            <el-form-item label="分销状态："> 
                <el-select v-model="searchForm.isSold" clearable>
                    <el-option label="未分销" value="0"></el-option>
                    <el-option label="已分销" value="1"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="卡状态："> 
                <el-select v-model="searchForm.cardState" clearable>
                    <el-option v-for="item in cardStateOption" :value="item.code" :key="item.id + item.description" :label="item.description"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="供应商名称："> 
                <el-select v-model="searchForm.supplierCode" clearable filterable>
                    <el-option v-for="item in branchSupplierOption" :value="item.id" :key="item.id" :label="item.name + '(' + item.alias + ')'"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="套餐组名称："> 
                <el-select v-model="searchForm.basePkgGroup" clearable filterable>
                    <el-option v-for="item in pkgGroup" :key="item.id" :value="item.id" :label="item.name"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="所属业务员：">
                <el-select v-model="searchForm.yewuId"   filterable>
                    <el-option v-for="item in yewuData" :value="item.id" :key="item.id" :label="item.name+'（'+item.sysUserAccountName+'）'"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="分销商：">
                <el-input v-model.trim="searchForm.agentName" @keyup.enter.native="getAdminCardListHandler" clearable></el-input>
            </el-form-item>
            <el-form-item label="ICCID号：">
                <el-input v-model.trim="searchForm.iccid" @keyup.enter.native="getAdminCardListHandler" clearable></el-input>
            </el-form-item>
            <el-form-item label="接入号：">
                <el-input v-model.trim="searchForm.intoNo" @keyup.enter.native="getAdminCardListHandler" clearable></el-input>
            </el-form-item>
             <el-form-item label="虚拟号：">
                <el-input v-model.trim="searchForm.virtualNo" @keyup.enter.native="getAdminCardListHandler" clearable></el-input>
            </el-form-item>
            <el-form-item label="卡板号段：" class="ICCIDRange">
                <el-col :span="11">
                    <el-input v-model.trim="searchForm.iccidStart" placeholder="支持虚拟号段" clearable></el-input>
                </el-col>
                <el-col :span="2" class="separate">-</el-col>
                <el-col :span="11">
                    <el-input v-model.trim="searchForm.iccidEnd" placeholder="搜索-分销-回收功能" clearable></el-input>
                </el-col>                
            </el-form-item>
            <br/>
            <el-form-item label="已使用流量(G)：" class="iccid_number_input">
                <el-row style="display:flex;width:400px;">
                    <el-col style="flex:3">
                        <el-select  clearable v-model="searchForm.op" placeholder="请选择">
                            <el-option
                            v-for="item in ops"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="1" class="separate"></el-col>
                    <el-col style="flex:7">
                        <el-input-number :min="0" v-model="searchForm.usedFlowRate" clearable></el-input-number>
                    </el-col>
                </el-row>                
                
            </el-form-item>


            <el-form-item label="未充值天数：">
                <el-input v-model.trim="searchForm.outDay" @keyup.enter.native="getAdminCardListHandler" clearable></el-input>
            </el-form-item>

            <!-- <el-form-item label="剩于流量(G)：" class="iccid_number_input">
                <el-row style="display:flex;width:400px;">
                    <el-col style="flex:3">
                        <el-select  clearable v-model="searchForm.op2" placeholder="请选择">
                            <el-option
                            v-for="item in ops"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="1" class="separate"></el-col>
                    <el-col style="flex:7">
                        <el-input-number :min="0" v-model="searchForm.plusFlowRate" clearable></el-input-number>
                    </el-col>
                </el-row>                
                
            </el-form-item> -->
            <br/>
            <el-form-item label="批量搜索：" class="iccid_textarea_range">
                <el-input
                    type="textarea"
                    :rows="2"
                    placeholder="请输入1个或多个ICCID号,多个请用逗号、空格、或者换行分隔"
                    v-model="searchForm.iccidStrs">
                    </el-input>
            </el-form-item>

            <!-- <el-form-item label="排序规则："> 
                <el-select v-model="searchForm.orderBy" clearable>
                    <el-option label="过期时间" value="expire_time"></el-option>
                    <el-option label="使用流量" value="use_flow"></el-option>
                </el-select>
            </el-form-item> -->

            <el-form-item class="btnArea">
                <el-button type="primary"  @click="getAdminCardListHandler" icon="el-icon-search">搜索查询</el-button>
                <el-button type="success"  @click="exportSimInfoHandle" plain icon="el-icon-download">导出Excel</el-button>
                <el-button type="primary"  @click="showSimHandle" icon="el-icon-s-ticket">SIM卡分销</el-button>
                <el-button type="danger" @click="simRecycleHandle" icon="el-icon-s-ticket">SIM卡回收</el-button>
                <el-button type="danger" @click="updatePkgUse" icon="el-icon-delete">批量删除</el-button>
                <el-button type="success" @click="updatePkgUse1">批量更新</el-button>
                <el-button type="warning"  @click="showSimHandle2" icon="el-icon-edit">批量变更卡状态</el-button>
                <el-button type="danger" @click="updatePkgUse2">未充值卡禁止充值</el-button>
                <el-button type="primary" @click="showSimHandle1" icon="el-icon-edit">批量转通道</el-button>
                <el-button type="success" @click="updatePkgUses" icon="el-icon-s-ticket">批量转套餐组</el-button>
            </el-form-item>
        </el-form> 
        <el-table :data="tbpg.tableData"
		border
		fit
		highlight-current-row
		style="width: 100%;"
		:header-cell-style="{background:'#f5f5f5'}"
		>
            <el-table-column label="ICCID号" width="180px" align="center">
                <template slot-scope="scope">
                    <a href="javascript:void(0)" @click="goToDetailPage(scope.row)">{{ scope.row.iccid }}</a>
                </template>
            </el-table-column>
            <el-table-column align="center" prop="intoNo" label="MSISDN" width="130px"></el-table-column>
             <el-table-column align="center" prop="virtualNo" label="虚拟号" width="130px"></el-table-column>
            <el-table-column align="center" prop="supplierName" label="供应商名称" width="120"></el-table-column>
            <el-table-column align="center" prop="alias" label="通道" width="80px"></el-table-column>
              <el-table-column  align="center"  label="实名状态">
                 <template v-slot="scope">
                    <el-tooltip v-if="scope.row.authName=='已实名'"  :content="scope.row.authName">
                        <p style="color:green"> {{scope.row.authName}}</p>
                    </el-tooltip>
                    <el-tooltip v-else  :content="scope.row.authName">
                        <p style="color:crimson"> {{scope.row.authName}}</p>
                    </el-tooltip> 
                </template>
            </el-table-column>
            <!-- <el-table-column align="center" prop="createTime" label="导入时间"  width="140px"></el-table-column> -->
            <el-table-column align="center" prop="batchNo" label="导入批次" width="80px"></el-table-column>
            <el-table-column align="center" prop="basePkgGroupName" label="套餐组"></el-table-column>
            <el-table-column align="center" label="总流量(G)" width="80px">
                <template slot-scope="scope">
                    {{ fluxMtoG(scope.row.flowRate) }}
                </template>
            </el-table-column>
            <el-table-column align="center"  label="已使用流量(G)" width="110px">
                <template slot-scope="scope"  >
                   <p style="color:#99BBFF"> {{ fluxMtoG(scope.row.usedFlowRate) }}</p>
                </template>
            </el-table-column>
            <el-table-column align="center" label="剩余流量(G)" width="100px">
                <template slot-scope="scope">
                    {{ decrease(fluxMtoG(scope.row.flowRate), fluxMtoG(scope.row.usedFlowRate)) }}
                </template>
            </el-table-column>
            <el-table-column align="center"  label="超流量(G)" width="110px">
                <template slot-scope="scope"  >
                   <p style="color:red"> {{ fluxMtoG(scope.row.outData) }}</p>
                </template>
            </el-table-column>
            <!-- <el-table-column align="center" prop="flowRatePercent" label="可用流量比" width="90px">
                <template v-slot="scope">
                    <span v-if="scope.row.flowRatePercent!=null && scope.row.flowRatePercent!=undefined && scope.row.flowRatePercent!=''">{{scope.row.flowRatePercent}} %</span>
                </template>
            </el-table-column> -->
            <el-table-column align="center" label="分销商" show-overflow-tooltip>
                <template slot-scope="scope">
                    <span style="color: #f54848;">{{ formatAgentNamePrefix(scope.row.agentPathNames)}}</span>{{ scope.row.agentPathNames}}
                </template>
            </el-table-column>

             <el-table-column  align="center"  label="卡状态"  width="100px">
                 <template v-slot="scope">
                    <el-tooltip v-if="scope.row.cardState==2"  :content="scope.row.cardStateName">
                        <p style="color:green"> {{scope.row.cardStateName}}</p>
                    </el-tooltip>
                     <el-tooltip v-else-if="scope.row.cardState==1||scope.row.cardState==0"  :content="scope.row.cardStateName" >
                        <p style="color:brown"> {{scope.row.cardStateName}}</p>
                    </el-tooltip>
                    <el-tooltip v-else  :content="scope.row.cardStateName">
                        <p style="color:crimson"> {{scope.row.cardStateName}}</p>
                    </el-tooltip> 
                </template>
            </el-table-column>
            <el-table-column align="center" label="数据状态" width="100px">
                <template v-slot="scope">
                    <el-tooltip v-if="scope.row.dataState == '开启'" :content="scope.row.dataState">
                        <p style="color:green"> {{ scope.row.dataState }}</p>
                    </el-tooltip>
                    <el-tooltip v-else :content="scope.row.dataState">
                        <p style="color:crimson"> {{ scope.row.dataState }}</p>
                    </el-tooltip>
                </template>
            </el-table-column>
            
            <el-table-column align="center" prop="isSoldName" label="分销状态" width="100"></el-table-column>
        </el-table>  
                <p v-if="searchForm.basePkgGroup!='' && searchForm.basePkgGroup!=null " style="color:red;text-align:center;">
            卡片总数：{{remark.total}}  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 在用卡数：{{remark.activing}}  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  累计激活：{{remark.allActive}} 
             &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 激活率：{{remark.activeParent}}%  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 使用流量：{{remark.totalData}} /G
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              产生利润：{{remark.price}} /元
            
             </p>

         <p v-else style="color:red;text-align:center;">可以根据查询套餐组，来显示具体的激活率和利润信息。  利润计算规则 利润=购买价-分润-成本价 （不包含管理员后台添加的套餐） </p>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
			background
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination>  
        <el-dialog :append-to-body="true"  title="卡片分销" :visible.sync="simHandleVisibale" width="600px" @close="cancel" :close-on-click-modal="false">
            <el-form ref="simHandleForm" :model="simHandleForm" :rules="simHandleRules" label-width="120px">
                <el-form-item label="代理商：" prop="agentId">
                    <el-select v-model="simHandleForm.agentId" filterable>
                        <el-option v-for="item in agentListOption" :value="item.id" :key="item.id" :label="item.name"></el-option>
                    </el-select>  
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="simDistributHandler">确 定</el-button>
            </div>
        </el-dialog>     
          <el-dialog :append-to-body="true"  title="批量转通道" :visible.sync="simHandleVisibale1" width="600px" @close="cancel" :close-on-click-modal="false">
            <el-form ref="searchForm" :model="searchForm"  label-width="120px">
                <el-form-item label="运营商：" prop="toSupplierCode">
                    <el-select v-model="searchForm.toSupplierCode" filterable>
                        <el-option v-for="item in branchSupplierOption" :value="item.id" :key="item.id" :label="item.name"></el-option>
                    </el-select>  
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="updatePkgUse3">确 定</el-button>
            </div>
        </el-dialog>
         <el-dialog :append-to-body="true"  title="批量转套餐组" :visible.sync="simHandleVisibales" width="600px" @close="cancel" :close-on-click-modal="false">
            <el-form ref="searchForm" :model="searchForm"  label-width="120px">
                <el-form-item label="新套餐组：" prop="basePkgGroupNew">
                    <el-select v-model="searchForm.basePkgGroupNew" filterable>
                        <el-option v-for="item in pkgGroup" :value="item.id" :key="item.id" :label="item.name"></el-option>
                    </el-select>  
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="updatePkgUse33">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog :append-to-body="true"  title="批量变更卡状态" :visible.sync="simHandleVisibale2" width="600px" @close="cancel" :close-on-click-modal="false">
            <el-form ref="searchForm" :model="searchForm" :rules="simHandleRules" label-width="120px">
                <el-form-item label="卡状态：" prop="cardState">
                    <el-select v-model="searchForm.cardState" filterable>
                        <el-option v-for="item in cardStateOption" :value="item.code" :key="item.code" :label="item.description"></el-option>
                    </el-select>  
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="simDistributHandler2">确 定</el-button>
            </div>
        </el-dialog>       
    </div>
</template>

<script>
import {getAdminCardList, simDistribut, simRecovery, getCardStateDict,exportSimInfo,simRecovery1,simRecovery2,simRecovery3,simRecovery4} from '@/api/sim.js'
import common from '@/utils/common.js'
export default {
    data(){         
        return {
              remark:{
                total:0,
                activing:0,
                allActive:0,
                activeParent:0,
                price:0,
                totalData:0
            },
            searchForm: {
                isSold: '',
                cardState: '',
                supplierCode: '',
                toSupplierCode:'',
                basePkgGroup: '',
                basePkgGroupNew:'',
                outDay:'',
                agentName: '',
                iccid: '',
                intoNo: '',
                iccidStart: '',
                iccidEnd: '',
                orderBy:'',
                usedFlowRate:null,
                plusFlowRate:null,
                op:'',
                op2:'',
                virtualNo:''
            },
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },    
            simHandleVisibale1:false,        
            simHandleVisibale: false,
            simHandleVisibale2: false,
            simHandleForm: {
                agentId: ''
            },
              yewuData: [],          
            pkgGroup: [],
            branchSupplierOption: [],
            agentListOption: [],
            cardStateOption: [],
            simHandleVisibales:false,
            virtualStateArray:[],
            simHandleRules: {
                agentId: [{required: true, message: '请选择代理商', trigger: 'change'}]
            },
            ops:[
                {label:'等于',value:"="},
                {label:'大于',value:">"}
            ]
        }
    },
    methods: {
        cancel(){
            this.simHandleVisibale = false;    
            this.simHandleVisibale2 = false;    
              this.simHandleVisibale1 = false;    
              this.simHandleVisibales=false;
             this.$refs.simHandleForm.resetFields();  
        },
        getAdminCardListHandler($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);
            if(data.usedFlowRate){
                data.usedFlowRate = data.usedFlowRate * 1024;
            }

            if(data.plusFlowRate){
                data.plusFlowRate = data.plusFlowRate * 1024; 
            }
            getAdminCardList(data).then(res => {
                common.listCallback(this, res, 'tbpg');
                 if(res.data.data.remarkMap) {
                    if(this.searchForm.basePkgGroup!=''&&this.searchForm.basePkgGroup!=null){
                         this.remark=res.data.data.remarkMap;
                    }
                }
            })
        },
         updatePkgUse(){
            var iccidStart = this.searchForm.iccidStart;
            var iccidEnd = this.searchForm.iccidEnd;
            var iccid=this.searchForm.iccid;
            var supplierCode=this.searchForm.supplierCode;
            var basePkgGroup=this.searchForm.basePkgGroup;
            var cardState=this.searchForm.cardState;
             var data = {
                    iccidStart,
                    iccidEnd,
                    iccid,
                    supplierCode,
                    basePkgGroup,
                    cardState
                }
             common.sysRequest("pkg/delete/pkg/batch/count",data, 'post').then(res => {
                 if(res.data.code == 200){
                     this.$confirm(  "一共要删除"+res.data.data+"条数据！！！"+'批量删除后数据无法恢复！ 搜索条件仅支持套餐组 卡状态 iccid  iccid号段这四个条件删除！ 请务必注意！', '提示', {
                confirmButtonText: '确定删除'+res.data.data+'数据',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
               
                simRecovery1(data).then(res => {
                    if(res.data.code == 200){
                        this.$message.success(res.data.message);
                        this.getAgentCardListHandle();
                    }else{
                        this.$message.error(res.data.message);
                    }
                }) 
            }).catch(()=>{})
                 }else{
                     this.$message.error(res.data.message);
                 }

            })    
           
        }, 

         updatePkgUse33(){
            var iccidStart = this.searchForm.iccidStart;
            var iccidEnd = this.searchForm.iccidEnd;
            var iccid=this.searchForm.iccid;
            var supplierCode=this.searchForm.supplierCode;
            var basePkgGroup=this.searchForm.basePkgGroup;
            var basePkgGroupNew=this.searchForm.basePkgGroupNew;
            var cardState=this.searchForm.cardState;
            var data = {
                    iccidStart,
                    iccidEnd,
                    iccid,
                    supplierCode,
                    basePkgGroup,
                    cardState,
                    basePkgGroupNew
                }
            common.sysRequest("sim/change/pkgGroup/serch/count",data, 'post').then(res => {
                 if(res.data.code == 200){
                    this.$confirm('一共要变更'+res.data.data+ '条数据，请注意搜索条件仅支持原套餐组 卡状态 iccid  卡号段,运营商这五个条件进行变更！ 请务必注意！', '提示', {
                confirmButtonText: '确定变更'+res.data.data+"条数据",
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                 common.sysRequest("sim/change/pkgGroup/serch",data, 'post').then(res => {
                 if(res.data.code == 200){
                    this.$message.success(res.data.message);
                    this.simHandleVisibales = false;
                    this.getAdminCardListHandler();
                 }else{
                     this.$message.error(res.data.message);
                 }

                 })    
            }).catch(()=>{})
                 }else{
                     this.$message.error(res.data.message);
                 }

                 })    

               
        },

         updatePkgUses(){
               this.simHandleVisibales=true;
            
        }, 
         updatePkgUse2(){
            var iccidStart = this.searchForm.iccidStart;
            var iccidEnd = this.searchForm.iccidEnd;
            var iccid=this.searchForm.iccid;
            var supplierId=this.searchForm.supplierCode;
            var groupId=this.searchForm.basePkgGroup;
            var cardState=this.searchForm.cardState;
            this.$confirm('搜索条件只有 套餐组和运营商两个选项生效。 确定要禁止充值嘛？（确认好卡将会变成运营商维护状态，用户不能不能充值。）', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                var data = {
                    iccidStart,
                    iccidEnd,
                    iccid,
                    supplierId,
                    groupId,
                    cardState
                }
                simRecovery3(data).then(res => {
                    if(res.data.code == 200){
                        this.$message.success(res.data.message);
                        this.getAgentCardListHandle();
                    }else{
                        this.$message.error(res.data.message);
                    }
                })
            }).catch(()=>{})
        }, 
        updatePkgUse3(){
            var iccidStart = this.searchForm.iccidStart;
            var iccidEnd = this.searchForm.iccidEnd;
            var iccidStrs=this.searchForm.iccidStrs;
            var supplierCode=this.searchForm.supplierCode;
            var basePkgGroup=this.searchForm.basePkgGroup;
            var cardState=this.searchForm.cardState;
            var toSupplierCode=this.searchForm.toSupplierCode;
             var data = {
                    iccidStart,
                    iccidEnd,
                    iccidStrs,
                    supplierCode,
                    basePkgGroup,
                    cardState,
                    toSupplierCode
                }
            common.sysRequest("sim/update/sim/supplier/info/count",data, 'post').then(res => {
                 if(res.data.code == 200){
                    this.$confirm('一共要变更'+res.data.data+'条数据！！请注意搜索条件只有 卡号段, 套餐组,运营商，卡状态和批量复制这五种，并且批量复制和搜索条件同时存在，只生效批量复制 确定要变更嘛？', '提示', {
                confirmButtonText: '确定变更'+res.data.data+"条数据", 
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
               
                simRecovery4(data).then(res => {
                    if(res.data.code == 200){
                     this.searchForm.iccidStrs='';
                        this.simHandleVisibale1=false;
                        this.$message.success(res.data.message);
                        this.getAdminCardListHandler();
                    }else{
                        this.$message.error(res.data.message);
                    }
                })
            }).catch(()=>{})
                 }else{
                     this.$message.error(res.data.message);
                 }

            })    
        }, 
        updatePkgUse1(){
            var iccidStart = this.searchForm.iccidStart;
            var iccidEnd = this.searchForm.iccidEnd;
            var iccid=this.searchForm.iccid;
            var supplierCode=this.searchForm.supplierCode;
            var basePkgGroup=this.searchForm.basePkgGroup;
            var cardState=this.searchForm.cardState;
            this.$confirm('只支持根据运营商，套餐组，ICCID号段进行批量更新状态和流量，确定要批量更新嘛？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                var data = {
                    iccidStart,
                    iccidEnd,
                    iccid,
                    supplierCode,
                    basePkgGroup,
                    cardState
                }
                simRecovery2(data).then(res => {
                    if(res.data.code == 200){
                        this.$message.success(res.data.message);
                        this.getAgentCardListHandle();
                    }else{
                        this.$message.error(res.data.message);
                    }
                })
            }).catch(()=>{})
        }, 
        goToDetailPage(row){
            this.$store.commit('menu/setFromPage', 'cardMgt');
            this.$store.commit('menu/setFromPageIccid', row.iccid);
            document.getElementById('cardDetailsMenu').click();
        },
        showSimHandle(){            
            var iccidStart = this.searchForm.iccidStart;
            var iccidEnd = this.searchForm.iccidEnd;
            if(iccidStart == "" || iccidEnd == ""){
                this.$message.error('请输入要分销的ICCID号段');
                return false;
            }else{
                this.simHandleVisibale = true;
                common.getAgentListOptionCom(this, 'agentListOption');
            }
        },
          showSimHandle2(){            
             this.$confirm('搜索条件只支持根据运营商 套餐组 卡号段进行变更， 确定要变更嘛？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                     this.simHandleVisibale2 = true;
            }).catch(()=>{})
        },
           showSimHandle1(){            
               this.simHandleVisibale1 = true;
        },
        simRecycleHandle(){
            var iccidStart = this.searchForm.iccidStart;
            var iccidEnd = this.searchForm.iccidEnd;
            if(iccidStart == "" || iccidEnd == ""){
                this.$message.error('请输入要回收的ICCID号段');
                return false;
            }
            this.$confirm('确定回收这批卡片吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                var data = {
                    iccidStart,
                    iccidEnd
                }
                simRecovery(data).then(res => {
                    if(res.data.code == 200){
                        this.$message.success(res.data.message);
                        this.getAdminCardListHandler();
                    }else{
                        this.$message.error(res.data.message);
                    }
                })
            }).catch(()=>{})
        },
        simDistributHandler(){
            this.$refs.simHandleForm.validate(valid => {
                if(valid){
                    var data = {
                        iccidStart: this.searchForm.iccidStart,
                        iccidEnd: this.searchForm.iccidEnd,
                        agentId: this.simHandleForm.agentId
                    }
                    simDistribut(data).then(res => {
                        if(res.data.code == 200){
                            this.$message.success('分销完成');
                            this.simHandleVisibale = false;
                            this.getAdminCardListHandler();
                        }else{
                            this.$message.error(res.data.message);
                        }
                    })
                }
            })
        },
         simDistributHandler2(){
                 var data = {
                        cardState: this.searchForm.cardState,
                        supplierId: this.searchForm.supplierCode,
                        groupId: this.searchForm.basePkgGroup,
                        iccidStart:this.searchForm.iccidStart,
                        iccidEnd:this.searchForm.iccidEnd
                    }
                    common.sysRequest("external/update/sim/state/state",data, 'post').then(res => {
                 if(res.data.code == 200){
                    this.$message.success('完成');
                    this.simHandleVisibale2 = false;
                    this.getAdminCardListHandler();
                 }else{
                     this.$message.error(res.data.message);
                 }

            })    
        },
        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getAdminCardListHandler();
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val;
            this.getAdminCardListHandler();
        },        
        exportSimInfoHandle(){//导出excel文件
            this.$confirm("您确定要导出SIM卡列表吗？", "提示" ,{          
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then( () => {

                let data = this.searchForm;
                if(data.usedFlowRate){
                    data.usedFlowRate = data.usedFlowRate * 1024;
                }
                if(data.plusFlowRate){
                    data.plusFlowRate = data.plusFlowRate * 1024; 
                }

                exportSimInfo(this.searchForm).then(res =>{
                    if(res.data.code == 200){
                        this.$message.success('数据导出中,请稍候去任务中心下载');
                    }else{
                        this.$message.error(res.data.msg);
                    }
                }).catch(err=>console.error(err)); 
            })          
        },

        //检查是不是自收款代理商
        formatAgentNamePrefix(name){

            let names = ['盛世蓝泰科技','云游互动云游卡','蔡伟成','野马通信','魅友通','四海龙腾'];
            let pre = '';
            if(name){
                names.forEach(function(currentValue){
                    if(name.indexOf(currentValue) == 0){
                        pre = '【自收款】'
                    }
                });
                return pre;
            }
            return '';
        }
        
    },
    created () {
         common.getAgentListOptionComs(this, 'yewuData');
        common.getPkgGroupListCom(this, 'pkgGroup');
        common.getBranchSupplierOptionCom(this, 'branchSupplierOption')
        getCardStateDict({}).then(res => {
            if(res.data.code == 200){
                this.cardStateOption = res.data.data;
                let virtualCardStateOption = [];
                for(let i=0; i<res.data.data.length; i++){
                    if(res.data.data[i].code<5 || res.data.data[i].code==11){
                        virtualCardStateOption.push(res.data.data[i]);
                    }                    
                }
                for (let i=0; i<virtualCardStateOption.length; i++) {
                    this.virtualStateArray.push(virtualCardStateOption[i].code);
                }
            }else{
                this.$message.error(res.data.message);
            }    
        })

        this.getAdminCardListHandler();
    }
}
</script>

<style lang="less" scoped>

</style>

